<template>
  <div class="commerce" v-if="role">
    <MainBackButton :forceHome="true" />
    <CommerceSettingsModal />

    <p class="has-text-left" style="padding-top: 15px; margin-bottom: 2px">
      <span class="title is-4" style="padding-left: 55px" @click="goHome">{{
        $t("home.commerce")
      }}</span>
      <span
        class="is-pulled-right"
        style="margin-right: 12px; margin-top: -5px"
      >
        <span
          class="button icon is-medium is-dark is-outlined is-rounded"
          style="padding: 5px 5px"
          @click="openCommerceSettings"
        >
          <i class="fa fa-cog" />
        </span>
      </span>
      <span
        class="
          button
          is-pulled-right is-link is-outlined
          has-text-weight-medium
        "
        style="margin-right: 12px; margin-top: -5px; height: 32px; padding: 4px"
        @click="goto('ecommerce')"
      >
        <i class="fa fa-bell" />&nbsp;Auto
      </span>
    </p>

    <div class="container" :key="z">
      <div class="notification">
        <!-- Business Type and Name (also address) -->
        <div class="field tags has-addons" style="margin-bottom: 0">
          <span class="single-line" style="padding-bottom: 10px">
            <span class="tag is-info is-medium" @click="workflowInfo">
              <i class="fa fa-store-alt" />
              &nbsp;{{ translateCategory(businessType) }}
            </span>
            <span
              class="
                tag
                is-white is-medium
                has-text-link has-text-weight-medium
              "
            >
              <!-- <a :href="businessMap" target="_blank">{{businessName}}</a>&nbsp; -->
              <a @click="goToShopProfile">{{ businessName }}</a
              >&nbsp;
            </span>
          </span>
        </div>

        <label class="label has-text-link">
          {{ $t("commerce.new-order") }}&nbsp;
          <span class="tag icon is-link is-rounded" @click="reset">
            <i class="fa fa-plus" />
          </span>
        </label>

        <span v-if="originalOrderlinaMobile">
          Orderlina order
          <span
            class="has-text-link"
            @click="callPhoneNumber(originalOrderlinaMobile)"
            >{{ originalOrderlinaMobile }}</span
          >
        </span>
        <!-- mobile -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined" @click="phoneInfo">
              <i class="fa fa-phone" />
            </a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="o.phone_number"
              type="number"
              :placeholder="mobilePlaceholder"
            />
          </div>
          <div class="control">
            <a
              class="button has-text-weight-medium is-outlined"
              style="width: 35px"
              @click="showDropoff(o)"
            >
              <i class="fa fa-map-marker-alt" :class="dropoffClass" />
              <!-- <i v-if="dropoff" class="fa fa-map-marker-alt has-text-success" />
              <i v-else class="fa fa-map-marker-alt has-text-danger" />-->
            </a>
          </div>
        </div>

        <!-- reference / amount -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined" @click="refInfo">
              <i class="fa fa-receipt" />
            </a>
          </div>
          <div class="control" v-if="isOrderlina">
            <input
              class="input is-warning"
              v-model="o.ref"
              :placeholder="refPlaceholder"
            />
          </div>
          <div class="control" v-else>
            <input
              class="input is-warning"
              v-model="o.ref"
              type="number"
              :placeholder="refPlaceholder"
            />
          </div>
          <div class="control">
            <a
              class="button is-outlined has-text-weight-medium"
              @click="priceInfo"
            >
              <span class="icon has-text-weight-bold">{{
                currencySymbol(business.country)
              }}</span>
            </a>
          </div>
          <div class="control">
            <input
              class="input is-warning"
              v-model="o.price"
              type="number"
              :placeholder="pricePlaceholder"
            />
          </div>
          <div class="control">
            <a
              class="button is-outlined has-text-weight-medium"
              @click="takePhoto"
            >
              <span class="icon has-text-weight-bold">
                <i class="fa fa-camera" :class="receiptPicClass" />
              </span>
            </a>
            <input
              type="file"
              ref="file"
              style="display: none"
              accept="image/png,image/jpeg,image/jpg,image/bmp"
              @change="uploadReceipt($event)"
            />
          </div>
        </div>

        <div class="field has-addons order">
          <div class="control">
            <a class="button has-text-weight-medium is-outlined">
              <span @click="paymentInfo">{{ $t("commerce.payment") }}</span>
            </a>
          </div>
          <div class="control is-expanded" v-if="cash">
            <a
              class="button is-info has-text-weight-medium is-fullwidth"
              :class="{ 'is-outlined': o.paymentMethod !== 'cash' }"
              @click="setPaymentMethod('cash')"
            >
              <i class="fa fa-coins" />
              &nbsp;{{ $t("cash") }}
            </a>
          </div>
          <div class="control is-expanded" v-if="digitalPaymentMethod">
            <a
              class="button is-info has-text-weight-medium is-fullwidth"
              :class="{ 'is-outlined': o.paymentMethod !== 'digital' }"
              @click="setPaymentMethod('digital')"
            >
              <!-- :disabled="!digitalPaymentMethod" -->
              <i class="fa fa-qrcode" />
              &nbsp;{{ digitalPaymentMethod }}
            </a>
          </div>
        </div>

        <div v-if="isDelivery" class="field has-addons order">
          <div class="control">
            <a class="button has-text-weight-medium is-outlined">
              <button
                class="delete is-small"
                style="margin-right: 9px"
                @click="toggleDelivery"
              />
              <span @click="deliveryInfo">{{ $t("home.delivery") }}</span>
            </a>
          </div>
          <div class="control is-expanded" v-if="express">
            <a
              class="button is-info has-text-weight-medium is-fullwidth"
              :class="{ 'is-outlined': o.deliveryMethod !== 'express' }"
              @click="setDeliveryMethod('express')"
            >
              <i class="fa fa-shipping-fast" />
              &nbsp;{{ $t("commerce.express") }}
            </a>
          </div>
          <div class="control is-expanded" v-if="batch">
            <a
              class="button is-info has-text-weight-medium is-fullwidth"
              :class="{ 'is-outlined': o.deliveryMethod !== 'batch' }"
              @click="setDeliveryMethod('batch')"
            >
              <i class="fa fa-stopwatch" />&nbsp;Batch
            </a>
          </div>
        </div>

        <div v-else class="field has-addons order">
          <div class="control is-expanded">
            <a class="button has-text-weight-medium is-info">
              <button
                class="delete is-small"
                style="margin-right: 9px"
                @click="toggleDelivery"
              />
              <span @click="takeAwayInfo">
                {{ $t("commerce.take-away") }}&nbsp;
                <i class="fa fa-shopping-basket" />
              </span>
            </a>
          </div>
        </div>

        <div class="button is-small is-rounded" @click="toggle = !toggle">
          <i class="fa fa-ellipsis-h" />
        </div>
        <div v-if="toggle" class="notification" style="margin-bottom: 0">
          <div v-if="o.receipt_pic">
            <img
              v-img
              class="banner"
              :src="o.receipt_pic"
              style="display: none"
            />
            <img :src="o.receipt_pic" @click="viewBigger" />
            <br />
            <p class="button is-warning" @click="$refs.file.click()">
              <i class="fa fa-camera" />
              &nbsp;{{ $t("commerce.retake-photo") }}
            </p>
          </div>
          <div v-else class="button is-warning" @click="$refs.file.click()">
            <i class="fa fa-camera" />
            &nbsp;{{ $t("commerce.take-photo-receipt") }}
          </div>
        </div>
        <div style="height: 12px" />
        <div v-if="isOrderlina">
          <div v-if="invalidOrderlinaAddress">
            <span>{{ $t("delivery.delivering-to") }}</span
            >&nbsp;
            <span class="has-text-danger">{{ o.dropoff.name }}</span>
            <span
              class="button is-danger is-fullwidth is-rounded"
              @click="openSetAddressModal"
              >{{ $t("delivery.confirm-exact-address") }}</span
            >
          </div>
          <div v-else>
            <span>{{ $t("delivery.delivering-to") }}</span
            >&nbsp;
            <span class="has-text-link">{{ o.dropoff.name }}</span>
          </div>
          <br />
        </div>
        <div v-if="!isOrderlina" class="field">
          <!-- <div class="field"> -->
          <div class="control">
            <button
              class="button is-primary is-fullwidth is-rounded"
              @click="sendOrder(o)"
            >
              <i class="fa fa-paper-plane" />
              &nbsp;{{ $t("commerce.customer-confirmation") }}
            </button>
          </div>
        </div>
        <!-- <div class="field is-grouped">
          <div class="control">
            <button class="button is-primary is-rounded" @click="openSetAddressModal">
              <i class="fa fa-map-marker-alt" />
              &nbsp;Set Address
            </button>
          </div>
          <div class="control is-expanded">
            <button class="button is-primary is-rounded" @click="sendOrder(o)">
              <i class="fa fa-paper-plane" />
              &nbsp;{{ $t("commerce.customer-confirmation") }}
            </button>
          </div>
        </div>-->
        <!-- <div style="height:12px" /> -->
        <div v-if="isDelivery" class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              :class="dispatchClass"
              @click="preDispatchOrder(o)"
            >
              <i class="fa fa-truck" />
              &nbsp;{{ $t("commerce.request-driver") }}
            </button>
          </div>
        </div>
        <p v-if="paymentMethodsError" class="has-text-danger">
          {{ paymentMethodsError }}
        </p>
        <p v-if="deliveryMethodsError" class="has-text-danger">
          {{ deliveryMethodsError }}
        </p>

        <div
          style="background-color: lightgrey; height: 1px; margin-bottom: 12px"
        />

        <span
          class="button is-link is-outlined is-small is-rounded"
          @click="update"
        >
          <i class="fa fa-sync" />
          &nbsp;{{ $t("update") }}
        </span>
      </div>
    </div>

    <CommerceHistoryList />
  </div>

  <div v-else class="notification">
    <i
      class="fa fa-kiwi-bird"
      style="margin-bottom: 10px; font-size: 5em; color: brown"
    />
    <p class="title has-text-info">{{ $t("commerce.not-allowed") }}</p>
    <a class="button is-success" @click="goHome">Go Home</a>
  </div>
</template>


<script>
import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import CommerceHistoryList from "@/components/CommerceHistoryList.vue";
import CommerceSettingsModal from "@/components/CommerceSettingsModal.vue";
import geo from "@/geo";
import imageCompression from "browser-image-compression";
const shortid = require("shortid");

export default {
  name: "Commerce",
  components: {
    MainBackButton,
    CommerceHistoryList,
    CommerceSettingsModal,
  },
  data() {
    return {
      z: 0, // for key
      o: this.newOrder(), //{ link: shortid.generate(), createdAt: new Date() }, // set from store
      isDelivery: true, // false means takeaway
      isOrderlina: false,
      invalidOrderlinaAddress: false,
      originalOrderlinaMobile: null,
      toggle: false,
      addressCallback: "COMMERCE_ADDRESS_CALLBACK",
      retryCount: 0, // retry if createTransaction fails
    };
  },
  activated() {
    this.checkVersion();
    this.loadOrder(); // load order form $store if exists
    this.checkQuery(); // orderlina integration
  },
  mounted() {
    EventBus.$on(this.addressCallback, (data) => {
      console.log(this.addressCallback, data);
      if (this.o.dropoff) {
        var combined = `${data.name} (${this.o.dropoff.address})`;
        this.o.dropoff.address = combined;
        this.o.dropoff.name = combined;
        this.o.dropoff.lat = data.lat;
        this.o.dropoff.lon = data.lon;
        this.o.map = this.googleMapURL(this.o.dropoff);
        this.invalidOrderlinaAddress = false;
      }
    });

    // document.addEventListener("visibilitychange", () => {
    //   if (document.visibilityState === "visible") {
    //     location.reload();
    //     // this.checkQuery(); // fix orderlina link issue
    //   }
    // });
  },
  computed: {
    dispatchClass() {
      console.log("z", this.z); // forces UI to update
      if (this.o.orderSent) return "is-large has-text-black pulse";
      return null;
    },
    receiptPicClass() {
      console.log("z", this.z); // forces UI to update
      if (this.o.receipt_pic) return "has-text-success";
      return "has-text-danger";
    },
    dropoffClass() {
      console.log("z", this.z); // forces UI to update
      if (this.o.dropoff) return "has-text-success";
      return "has-text-danger";
    },
    pricePlaceholder() {
      return this.$t("price");
    },
    refPlaceholder() {
      return this.$t("reference");
    },
    mobilePlaceholder() {
      return this.$t("commerce.customer-mobile");
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    digitalPaymentMethod() {
      if (!this.workflow.data.digital_payment) return null;
      return this.workflow.data.digital_payment[0];
    },
    digitalPaymentID() {
      if (!this.workflow.data.digital_payment) return null;
      return this.workflow.data.digital_payment[1];
    },
    cash() {
      return this.workflow.data.cash;
    },
    batch() {
      return this.workflow.data.batch;
    },
    express() {
      return this.workflow.data.express;
    },
    business() {
      return this.role.business;
    },
    businessName() {
      return this.business.name;
    },
    businessType() {
      return this.business.business_type;
    },
    businessNameAndType() {
      return `${this.businessName} (${this.businessType})`;
    },
    businessMap() {
      var lat = this.business.lat;
      var lon = this.business.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    paymentMethodsError() {
      if (!this.workflow.data.cash && !this.workflow.data.digital_payment) {
        return "Payment methods not setup";
      }
      return null;
    },
    deliveryMethodsError() {
      if (!this.workflow.data.express && !this.workflow.data.batch) {
        return "Delivery methods not setup";
      }
      return null;
    },
    vehicleWorkflowID() {
      var express = this.workflow.data.express; // tuk tuk, motorbike, songthaew etc
      var batch = this.workflow.data.batch;
      if (this.o.deliveryMethod === "express" && express) return express; // workflowID
      if (this.o.deliveryMethod === "batch" && batch) return batch; // workflowID
      return null;
    },
  },
  methods: {
    openSetAddressModal() {
      EventBus.$emit("SET_ADDRESS_MODAL", this.addressCallback);
    },
    viewBigger() {
      this.$el.querySelector(".banner").click();
    },
    takePhoto() {
      if (!this.o.receipt_pic) return this.$refs.file.click();
      this.toggle = true;
    },
    uploadReceipt(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.o.link + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.business.id,
                imageType: "receipt",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  this.o.receipt_pic = JSON.parse(res.data.body).Location;
                  // this.o.receipt_pic = res.data.data.thumb.url;
                  this.save();
                  this.toggle = true; // open pic toggle
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
    loadOrder() {
      if (this.$store.state.commerceOrder) {
        var createdAt = new Date(this.$store.state.commerceOrder.createdAt);
        var ageMinutes = (new Date() - createdAt) / (1000 * 60);
        console.log("ageMinutes", ageMinutes);
        if (ageMinutes > 60 * 12) {
          return this.clearOrder(); // if more than 12 hours old create new order
        } else {
          this.o = this.$store.state.commerceOrder;
          this.isOrderlina = this.o.is_orderlina;
        }
      }
    },
    newOrder() {
      return { link: shortid.generate(), createdAt: new Date() };
    },
    clearOrder() {
      // this.clearQuery(); // reset query, e.g. if orderlina
      this.$store.commit("setCommerceOrder", null);
      this.o = this.newOrder(); // set from store
      this.invalidOrderlinaAddress = false;
      this.isOrderlina = false;
      this.originalOrderlinaMobile = null;
      this.retryCount = 0;
      this.save();
    },
    checkQuery() {
      if (this.$route.fullPath === "/commerce") return; // means no query
      var data = {
        query: this.$route.query,
        fullPath: this.$route.fullPath,
      };
      this.$store.dispatch("logCustom", {
        log_type: "orderlina_url",
        data: JSON.stringify(data),
      });
      if (this.$route.fullPath.includes("#")) {
        this.$router.replace(this.$route.fullPath.replace("#", "no."));
      }
      var query = this.$route.query;
      if (!query.phone_number) return;
      console.log("orderlina query", query);
      console.log("orderlina hash", this.$route.hash);
      console.log("orderlina route", this.$route.fullPath);
      this.isOrderlina = true;
      this.o.is_orderlina = true;
      this.o.link = shortid.generate(); // set link
      this.originalOrderlinaMobile = query.phone_number;
      this.o.phone_number = this.parseOrderlinaMobile(query.phone_number);
      this.o.price = parseInt(query.price); // should be float
      this.o.ref = query.ref; // this can be string letters/numbers/symbols
      this.o.orderSent = true; // default for orderlina, all info collected already
      var name = query.address;
      var lat = query.lat;
      var lon = query.lon;
      if (lat === "" || isNaN(lat)) this.invalidOrderlinaAddress = true;
      this.o.dropoff = {
        address: name,
        name: name,
        lat: lat,
        lon: lon,
      };
      this.o.map = this.googleMapURL(this.o.dropoff);
      ////////////////////////////////
      // this.paymentMethod = query.payment_method;
      // this.paymentID = query.payment_id;
      // this.businessType = query.business_type;
      // this.businessName = query.business_name;
      // this.businessLat = query.lat;
      // this.businessLon = query.lon;
      // this.country = query.country;
    },
    // turn into all digits phone number, later convert into int'l
    parseOrderlinaMobile(str) {
      str = str.replace(/\.|-|\s/g, "");
      if (str.startsWith("00")) return str; // 00 int'l
      if (str.startsWith("0")) return str; // normal thai
      if (str.startsWith("+")) return "00" + str.substring(1); // thai phone number
      if (str.startsWith("66")) return "0" + str.substring(2); // thai phone number
      if (str.length === 9 && !str.startsWith("0")) return "0" + str; // thai number forgot 0
      this.console("convertPhoneNumber error", str);
      return str;
    },
    goToShopProfile() {
      this.$router.push(`/shop/${this.business.id}`);
    },
    reset() {
      this.$swal({
        title: this.$t("commerce.create-new-order"),
        text: this.$t("commerce.make-sure"),
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("commerce.create-new"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.value) {
          this.clearOrder();
          this.clearURLQuery();
          // location.reload();
          this.$swal({
            type: "success",
            title: "New Order Created",
            showConfirmButton: false,
            timer: 600,
          });
        }
      });
    },
    save() {
      this.$store.commit("setCommerceOrder", this.o);
      this.z += 1; // force re-render component
    },
    toggleDelivery() {
      this.isDelivery = !this.isDelivery;
      if (this.isDelivery) this.o.deliveryMethod = null;
      else this.o.deliveryMethod = "takeaway";
    },
    openDeliveryHistory() {
      this.displayModal(".delivery-history-modal"); // re-use for commerce
      EventBus.$emit("DELIVERY_HISTORY", this.workflow.id);
    },
    openCommerceSettings() {
      this.displayModal(".commerce-settings-modal");
      EventBus.$emit("OPEN_COMMERCE_SETTINGS");
    },
    workflowInfo() {
      this.save(); // hack to test save and re-render key
      var YAML = require("json2yaml");
      var ymlText = YAML.stringify(this.workflow.data);
      // var json = JSON.stringify(this.workflow.data, null, 2);
      // json = json.substring(1, json.length - 1).replace(/^\s+|\s+$/g, ""); // trim {} and white space
      this.$swal({
        html: `<div style="text-align:left; white-space:pre-line; font-size:0.8em">${ymlText}</div>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    phoneInfo() {
      var txt1 = this.$t("commerce.mobile-hint-1");
      var txt2 = this.$t("commerce.mobile-hint-2");
      this.$swal({
        title: `<i class='fa fa-phone' style='color:blue'></i>`,
        html: `${txt1}<br><br>${txt2}`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    refInfo() {
      this.$swal({
        title: `<i class='fa fa-receipt' style='color:blue'></i>`,
        html: this.$t("commerce.ref-number-hint"),
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    priceInfo() {
      var txt1 = this.$t("commerce.price-hint-1");
      var txt2 = this.$t("commerce.price-hint-2");
      this.$swal({
        title: `<i class='fa fa-coins' style='color:blue'></i>`,
        html: `${txt1}<br><br>${txt2}`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    paymentInfo() {
      this.$swal({
        title: `<i class='fa fa-credit-card' style='color:blue'></i>&nbsp;<i class='fa fa-money-bill-wave' style='color:blue'></i>`,
        html: `How will the customer be paying?`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    deliveryInfo() {
      this.$swal({
        title: `<i class='fa fa-shipping-fast' style='color:blue'></i>`,
        html: `Choose delivery type.<br><br>Express delivery will use an on-demand vehicle to delivery ASAP.<br><br>Batch delivery will use a larger vehicle to pick up and delivery at the specified time.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    takeAwayInfo() {
      this.$swal({
        title: `<i class='fa fa-walking' style='color:blue'></i>`,
        html: `Customer will come to pick up the order at the shop. No delivery needed.`,
        showConfirmButton: false,
      });
    },
    setDeliveryMethod(method) {
      this.o.deliveryMethod = method;
      this.save();
    },
    setPaymentMethod(method) {
      this.o.paymentMethod = method;
      this.save();
    },
    guessDeliveryMethod() {
      if (this.express) this.setDeliveryMethod("express");
    },
    guessPaymentMethod() {
      if (this.cash) this.setPaymentMethod("cash");
      if (this.digitalPaymentMethod) this.setPaymentMethod("digital");
    },
    validOrder(o) {
      if (!o.deliveryMethod) this.guessDeliveryMethod();
      if (!o.paymentMethod) this.guessPaymentMethod();
      if (!o.price || !o.ref || !o.deliveryMethod || !o.paymentMethod) {
        var unk = `<i class="fa fa-question" style="color:red"></i>`;
        var txt1 = this.$t("commerce.please-fill");
        var txt2 = this.$t("profile.mobile"); //Mobile
        var txt3 = this.$t("reference"); //Reference
        var txt4 = this.$t("price"); //Price
        var txt5 = this.$t("commerce.payment"); //Payment
        var txt6 = this.$t("commerce.delivery"); //Delivery
        this.$swal({
          type: "info",
          html: `${txt1}<br><br>
          <div style='text-align:left'>
          ${txt2}: <strong>${o.phone_number}</strong><br>
          ${txt3}: <strong>${o.ref || unk}</strong><br>
          ${txt4}: <strong>${o.price || unk}</strong><br>
          ${txt5}: <strong>${o.paymentMethod || unk}</strong><br>
          ${txt6}: <strong>${o.deliveryMethod || unk}</strong>
          </div>`,
          confirmButtonText: this.$t("okay"),
          showCloseButton: true,
        });
        return false;
      }
      return true;
    },
    invalidCoords(o) {
      if (!o.dropoff) return false; // normal order this won't be set yet, ordalina will
      if (!o.dropoff.lat) return true;
      if (!o.dropoff.lon) return true;
      return false;
    },
    preDispatchOrder(o) {
      if (!this.validPhoneNumber(this.o)) return;
      if (!this.validOrder(o)) return;
      if (this.invalidCoords(o)) {
        this.openSetAddressModal();
        return;
      }
      if (this.isOrderlina) {
        if (this.invalidOrderlinaAddress || this.invalidCoords(o))
          this.openSetAddressModal();
        else this.confirmDispatchOrder(o);
        return;
      }
      // normal flow if not orderlina order
      this.checkAddressNew(o).then(() => {
        this.confirmDispatchOrder(o);
      });
    },
    invalidDistance(o) {
      var dist = this.tripDistance(this.business, o.dropoff);
      if (dist > 12500) {
        var km = this.metersToKM(dist, 1);
        var txt1 = this.$t("delivery.max-distance-1", { km: km });
        var txt2 = this.$t("delivery.max-distance-2");
        this.warningAlert(`${txt1}<br><br>${txt2}`);
        return true;
      }
      return false;
    },
    confirmDispatchOrder(o) {
      if (this.invalidDistance(o)) return;
      var txt1 = this.$t("commerce.dispatch-text-1");
      var txt2 = this.$t("commerce.dispatch-text-2");
      var deliveringTo = this.$t("delivery.delivering-to");
      var distance = this.$t("shop.distance");
      var address = this.o.dropoff.address;
      var km = this.tripDistance(this.business, this.o.dropoff);
      this.$swal({
        title: "🏎  🏍  🚚",
        html: `${txt1}<br><span style='font-size:1.6em'>🙌🏽</span>
        <br><br>${txt2}
        <br><br>
        <div style='text-align:left'>
        <button style='background-color:yellow'>${deliveringTo}</button>
        <br>${address}<br><i style='font-size:0.8em'>${km}m ${distance}</i></div>`,
        showCancelButton: true,
        confirmButtonText: this.$t("commerce.request-driver"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        if (val.value) {
          this.retryCount = 0; // reset every time user tries transaction
          this.createTransaction(o);
        }
      });
    },
    shareOrder(o) {
      if (!navigator.share) {
        var txt = `Sharing not supported by this device.<br><br>Send as SMS or paste into a chat.`;
        this.warningAlert(txt);
        return;
      }
      navigator
        .share({
          text: this.$t("delivery.share-message"), //"TUK Delivery📦 Click link to confirm delivery details!🍱🥂",
          url: this.shortLink(o),
        })
        .then(() => console.log("Successful share"))
        .catch((err) => console.log("Error sharing", err));
    },
    shortLinkMessage(o) {
      var link = this.shortLink(o);
      return `${this.$t("delivery.share-message")} ${link}`;
    },
    smsOrder(o) {
      var msg = this.shortLinkMessage(o);
      this.sendSMS(msg, o.phone_number);
      var txt = `Please check customer has received SMS in a minute. If not received send via chat.`;
      this.thankYou(txt);
    },
    shortLink(o) {
      var url = process.env.VUE_APP_HOST;
      return `${url}/q/${o.link}`;
    },
    validPhoneNumber(o, hideAlert) {
      if (!o.phone_number || o.phone_number.length < 8) {
        if (!hideAlert)
          this.warningAlert(this.$t("commerce.enter-valid-mobile"));
        return false;
      }
      return true;
    },
    orderConfirmationLink(o) {
      var user = this.userID(); // send notification back to this user
      var workflowID = this.workflow.id;
      var type = this.business.business_type;
      var name = this.business.name;
      var lat = this.business.lat;
      var lon = this.business.lon;
      var country = this.business.country;
      var url = `/order_confirmation/${o.phone_number}?created_by=${user}&workflow_id=${workflowID}&business_type=${type}&business_name=${name}&lat=${lat}&lon=${lon}&price=${o.price}&country=${country}`;
      if (o.paymentMethod === "cash") {
        return `${url}&payment_method=cash`;
      }
      var method = this.digitalPaymentMethod;
      var id = this.digitalPaymentID;
      return `${url}&payment_method=${method}&payment_id=${id}`;
    },
    sendOrder(o) {
      if (!this.validPhoneNumber(o)) return;
      if (!this.validOrder(o)) return;
      o.orderSent = true;
      this.save(); // save order to store
      var longLink = this.orderConfirmationLink(o);
      this.shortenLink(longLink, o.link, 24 * 60); // 24 hours validity
      var link = this.shortLink(o);
      var share = this.$t("share");
      var copied = this.$t("commerce.link-copied");
      this.$copyText(this.shortLinkMessage(o)); // copy to clipboard
      this.$swal({
        title: this.$t("commerce.send-to-customer"),
        html: `<strong><i class="fa fa-receipt"></i> ${o.ref}</strong>&nbsp;-
        ${copied}<br><br><a href='${link}'>${link}</a>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: `<i class='fa fa-share-alt'></i> ${share}`,
        cancelButtonText: "<i class='fa fa-sms'></i> SMS",
        cancelButtonColor: "#8565c4",
      }).then((val) => {
        console.log("sendOrder", val);
        if (val.value) this.shareOrder(o);
        if (val.dismiss === "cancel") this.smsOrder(o);
      });
    },
    showDropoff(o) {
      this.save();
      if (!this.validPhoneNumber(o)) return;
      if (!o.dropoff) return this.checkAddress(o, this.showDropoff); // check for address
      var d = o.dropoff;
      var minsAgo = (new Date() - new Date(o.dropoff.updated_at)) / (1000 * 60);
      var updated = `Updated ${Math.round(minsAgo)} minutes ago`;
      var addonHTML = `<br><br><i>${d.address}</i><br><br>
        <i class="fa fa-pencil-alt"></i>&nbsp;Notes: ${o.dropoff.notes}<br><br>
        <span style="font-size:0.8em"><i class="fa fa-clock"></i>&nbsp;${updated}</span>`;
      if (this.isOrderlina) {
        // var lat = this.o.dropoff.lat;
        // var lon = this.o.dropoff.lon;
        addonHTML = ""; //`<br><br><i>${lat},${lon}</i>`;
        if (this.invalidOrderlinaAddress) {
          var invalidCoords = this.$t("delivery.invalid-coords-warning");
          addonHTML = `<br><br><span style='color:red'>${invalidCoords}</span>`;
        }
      }
      this.$swal({
        html: `<div style='text-align:left'>
        <a href="tel:${o.phone_number}"><i class="fa fa-phone"></i>&nbsp;
        <strong>${o.phone_number}</strong></a><br><br>
        <a href="${o.map}" target="_blank"><i class="fa fa-map-marked-alt"></i>&nbsp;<strong>${d.name}</strong></a>
        ${addonHTML}
        </div>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    update() {
      EventBus.$emit("UPDATE_COMMERCE_HISTORY");
    },
    checkAddress(o, callback) {
      // given phone number get home address of user, set as dropoff
      var txt1 = this.$t("commerce.delivery-warning-1");
      var txt2 = this.$t("commerce.delivery-warning-2");
      var loader = this.loadingDots("cyan");
      this.$store
        .dispatch("getUserAddress", o.phone_number)
        .then((res) => {
          console.log("getUserAddress", res);
          o.dropoff = res.data;
          o.map = this.googleMapURL(o.dropoff);
          this.save();
          callback(o);
        })
        .catch((err) => {
          var txt = `${txt1}<br><br>${txt2}<br><span style='font-size:1.6em'>🙏🏽</span>`;
          this.$swal({
            type: "warning",
            html: txt,
            showConfirmButton: false,
            showCloseButton: true,
          });
          console.error(err);
        })
        .finally(() => loader.hide());
    },
    checkAddressNew(o) {
      return new Promise((resolve, reject) => {
        var txt1 = this.$t("commerce.delivery-warning-1");
        var txt2 = this.$t("commerce.delivery-warning-2");
        var loader = this.loadingDots("cyan");
        this.$store
          .dispatch("getUserAddress", o.phone_number)
          .then((res) => {
            console.log("getUserAddress", res);
            o.dropoff = res.data;
            o.map = this.googleMapURL(o.dropoff);
            this.save();
            resolve(res);
          })
          .catch((err) => {
            var txt = `${txt1}<br><br>${txt2}<br><span style='font-size:1.6em'>🙏🏽</span>`;
            this.$swal({
              type: "warning",
              html: txt,
              showConfirmButton: false,
              showCloseButton: true,
            });
            console.error(err);
            reject(err);
          })
          .finally(() => loader.hide());
      });
    },
    googleMapURL(coords) {
      return `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
    },
    getFare(p, d) {
      var dist = this.tripDistance(p, d);
      var price = 80;
      if (dist < 10000) price = 60;
      if (dist < 5000) price = 40;
      return {
        version: "v1",
        price: price,
        discount: 0,
        cash: price,
        tukpay: 0,
        distance: dist,
      };
    },
    tripDistance(p, d) {
      var dist = geo.distanceToUserInMeters(p, d);
      var drivingDist = Math.round(dist * 1.25); //
      this.console(`tripDistance ${dist} (${drivingDist})`);
      return drivingDist;
    },
    createTransaction(o) {
      var pickup = {
        id: "special_stop",
        name: this.business.name,
        lat: this.business.lat,
        lon: this.business.lon,
      };
      var dropoff = {
        id: "special_stop",
        name: o.dropoff.name,
        lat: o.dropoff.lat,
        lon: o.dropoff.lon,
      };
      var delivery = {
        type: this.businessType,
        business_name: this.businessName,
        workflow_id: this.role.workflow_id,
        agent_id: this.userID(), // so you can get notified of delivery events
        order_value: o.price,
        payment_method: o.paymentMethod,
        receipt_pic: o.receipt_pic,
        short_link: o.link,
      };
      var fare = this.getFare(pickup, o.dropoff);
      var obj = {
        type: "delivery",
        pickup_stop: pickup,
        dropoff_stop: dropoff,
        fare: fare,
        ref: o.ref, // reference number
        delivery: delivery,
      };
      // adjustments on order_value and such for orderlina orders
      if (this.isOrderlina) {
        delivery.partner = "Orderlina";
        delivery.order_value = delivery.order_value - fare.price;
        if (delivery.order_value < 0) {
          this.warningAlert(`Please check the order value! Cannot be less than 0
          <br><br>Order value: ${delivery.order_value}
          <br>Delivery fee: ${fare.price}`);
          return;
        }
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Delivery", //role.workflowType, << set this based on the driverID?
          workflow_id: this.vehicleWorkflowID, // express hack
          business_id: this.role.business_id, // restaurant business ID
          created_by: this.convertPhoneNumber(o.phone_number),
          // handled_by: "express",
          data: obj,
        })
        .then(() => {
          this.$swal({
            title: this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.update();
          this.clearOrder();
        })
        .catch((err) => {
          console.error("commerce createTransaction", err);
          if (err.message === "Network Error" && this.retryCount < 3) {
            setTimeout(() => this.createTransaction(o), 1500);
            this.retryCount += 1;
          } else {
            this.apiError(err);
          }
        })
        .finally(() => loader.hide());
    },
    createPartialTransaction(o) {
      var pickup = {
        id: "special_stop",
        name: this.business.name,
        lat: this.business.lat,
        lon: this.business.lon,
      };
      var dropoff = {
        id: "special_stop",
        name: o.dropoff.name,
        lat: o.dropoff.lat,
        lon: o.dropoff.lon,
      };
      var delivery = {
        type: this.businessType,
        business_name: this.businessName,
        workflow_id: this.role.workflow_id,
        agent_id: this.userID(), // so you can get notified of delivery events
        order_value: o.price,
        payment_method: o.paymentMethod,
        receipt_pic: o.receipt_pic,
        short_link: o.link,
      };
      var obj = {
        type: "delivery",
        pickup_stop: pickup,
        dropoff_stop: dropoff,
        fare: this.getFare(pickup, o.dropoff),
        ref: o.ref, // reference number
        delivery: delivery,
      };
      // obj.fare.distance = this.tripDistance(pickup, o.dropoff);
      var loader = this.loadingDots();
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Delivery", //role.workflowType, << set this based on the driverID?
          workflow_id: this.vehicleWorkflowID, // express hack
          business_id: this.role.business_id, // restaurant business ID
          created_by: this.convertPhoneNumber(o.phone_number),
          // handled_by: "express",
          data: obj,
        })
        .then(() => {
          this.$swal({
            title: this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.update();
          this.clearOrder();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 1rem;
  padding-bottom: 8px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
img {
  border-radius: 8px;
  border: 2px solid gold;
  height: 150px;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 0, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(255, 0, 255, 0.95);
  }
}
.pulse {
  animation: shadow-pulse 0.6s infinite;
}
</style>